/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FormSectionAccordion } from 'components/accordion/FormSectionAccordion'
import { useAlert } from 'components/alert'
import { FormApi } from 'final-form'
import { MetaRoot } from 'util/metaPath'
import { EditableList, useEditableListField } from 'view/atendimentos/detail/components/EditableList'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { AvaliacaoFormModel } from '../../AvaliacaoForm'
import { AlergiasReacoesForm } from './AlergiasReacoesForm'
import { AlergiasReacoesTable } from './AlergiasReacoesTable'
import { AlergiaReacaoModel } from './model'

export interface AlergiasReacoesFieldProps {
  name: MetaRoot<AvaliacaoFormModel>
  cidadao?: CidadaoAtendimento
  prontuarioId: ID
  dataAtendimento: Instant
}

export function AlergiasReacoesField(props: AlergiasReacoesFieldProps) {
  const { name, cidadao, prontuarioId, dataAtendimento } = props
  const alert = useAlert()

  const {
    handleSubmit,
    handleRowChanged,
    removeItem,
    input: { value },
  } = useEditableListField({
    name: name.alergias,
  })

  const handleAddItem = (values: AlergiaReacaoModel, api: FormApi<AlergiaReacaoModel>) => {
    handleSubmit(values, api)
    alert('success', alertMessageAddAlergia(values))
  }

  const handleEditItem = (values: AlergiaReacaoModel) => {
    handleRowChanged(values)
    alert('success', alertMessageEditAlergia(values))
  }

  const handleCancel = () => {
    alert('success', alertMessageCancelAddAlergia())
  }

  return (
    <FormSectionAccordion uuid='alergias' name={name.openedAccordions} title='Alergias e reações adversas'>
      <EditableList style={{ borderWidth: 0 }}>
        <AlergiasReacoesForm
          formValues={value}
          prontuarioId={prontuarioId}
          cidadao={cidadao}
          dataAtendimento={dataAtendimento}
          onSubmit={handleAddItem}
          onCancel={handleCancel}
        />

        <AlergiasReacoesTable
          alergias={value}
          cidadao={cidadao}
          prontuarioId={prontuarioId}
          handleEditItem={handleEditItem}
          handleRemoveItem={removeItem}
        />
      </EditableList>
    </FormSectionAccordion>
  )
}

const alertMessageAddAlergia = (model: AlergiaReacaoModel) =>
  model.alergiaReacaoEvoluir
    ? `A avaliação da alergia/reação adversa à ${
        model.substanciaCbara?.nome ?? model.substanciaImunobiologico?.nome
      } foi incluída na Lista de alergias/reações adversas.`
    : `A alergia/reação adversa à ${
        model.substanciaCbara?.nome ?? model.substanciaImunobiologico?.nome
      } foi incluída na Lista de alergias/reações adversas.`

const alertMessageEditAlergia = (model: AlergiaReacaoModel) =>
  `A avaliação da alergia/reação adversa à ${
    model.substanciaCbara?.nome ?? model.substanciaImunobiologico?.nome
  } foi alterada na Lista de alergias/reações adversas.`

const alertMessageCancelAddAlergia = () => `A avaliação da alergia/reação adversa foi cancelada.`
